import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NoteModel } from 'src/app/models/notes/note.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class NoteApiClient {


    readonly controllerEndPoint = environment.apiUrl + "/fe-api/note";

    constructor(private httpClient: HttpClient) { }

    /**
     * Get all Notes for a request
     * @param requestGuid
     * @returns 
     */
    Get(requestGuid: string): Observable<NoteModel[]> {
        return this.httpClient.get<NoteModel[]>(this.controllerEndPoint + "/request/" + requestGuid);
    }

    /**
     * Create a new Note for the given request and logged in user
     * @param requestGuid 
     * @param text 
     * @returns 
     */
    create(requestGuid: string, text: string): Observable<any> {
        var body /*: CreateNoteModel*/ = {
            RequestGuid: requestGuid,
            Text: text
        };
        return this.httpClient.post<any>(this.controllerEndPoint + "", body);
    }

    /**
     * Change the existing Note
     * @param noteGuid 
     * @param newText 
     * @returns 
     */
    edit(noteGuid: string, newText: string): Observable<any> {
        var body /*: EditNoteModel*/ = {
            NoteGuid: noteGuid,
            Text: newText
        };
        return this.httpClient.post<any>(this.controllerEndPoint + "/edit", body);
    }

    /**
     * Remove the note
     * @param noteGuid 
     * @returns 
     */
    delete(noteGuid: string): Observable<any> {
        var body /*: DeleteNoteModel*/ = {
            NoteGuid: noteGuid
        };
        return this.httpClient.post<any>(this.controllerEndPoint + "/delete", body);
    }

}


